import React from 'react';
import getByteLength from '@/src/module/jhc-getByteLength';

export default class FormInputText extends React.Component {

	constructor (props) {
    super(props);
    this.name= this.props.data.name;
    this.nameKr= this.props.data.nameKr;
    this.targetElem= React.createRef();
    this.placeholder= this.props.placeholder ? this.props.placeholder : `${this.nameKr}을 입력해주세요`;
  }

  componentDidMount () {
    this.props.onCreateRef(this.name, this.targetElem.current);
  }

  handler= (name, e)=> {
    const strLength= getByteLength(e.target.value);
    if( strLength > this.props.data.maxLen ) {
      alert('길이를 초과했습니다.')
      return;
    }
    this.props.setData(name, e);
  }
  
	render () {
		return (

      <div 
        ref={this.targetElem}
        className="bd-ani-target bd-tr flx-cl w100 mg-h10 m-flx-col"
      >
        <div className="w200p pd-r10 m-w100 m-flx-cl">
					<label className="w100 iblock-box txt-right m-txt-left m-wa m-pd-r5">
						<span className="ft-rd ft-bi">* </span>
						<span className="ft4 ft-md m-ft35">{this.nameKr}</span>
					</label>
					<p className={`ft5 ft-bl txt-right`}>
						{this.props.data.comment}
					</p>
				</div>
				{/* <label className="w150p txt-right pd-r15 m-w100 m-txt-left">
					<span className="ft4 ft-md m-ft35">{this.nameKr}</span>
				</label> */}
        <input 
          onChange={this.handler.bind(null, this.name)} 
          type={this.props.type || 'text' }
          name={this.name} 
          title={this.nameKr}
          value={ this.props.data.value }
          readOnly={this.props.fix || false}
          placeholder={this.placeholder}
          className=
            {`${this.props.fix && 'ft-gr '}data data-item flx-itm-r w100 pd-10 ft4 m-ft35 bd-dg m-pd-7`}
				/>
			</div>

		);
	}

}